import { CrewAvailability } from "src/app/core/graphql/generated/gen-types";

export const Availabilities = [
    { availability: CrewAvailability.Yes, icon: 'check_circle', color: '#50C878' },
    { availability: CrewAvailability.Maybe, icon: 'help', color: '#ffca28' },
    { availability: CrewAvailability.No, icon: 'cancel', color: '#B80F0A' },
    { availability: CrewAvailability.Unk, icon: 'block', color: 'grey' },
];